import type { ReactNode } from 'react'
import Box from '@mui/material/Box'
import { surveyEntryPageRootSx } from '../styles/surveyEntryStyles'
import { SurveyEntryCard } from './SurveyEntryCard'

interface SurveyEntryScreenProps {
  readonly children: ReactNode
  readonly testId?: string
}

/** Figma 5074-14025 — full-width survey card column (logo inside card per 5074-14035). */
export function SurveyEntryScreen({ children, testId = 'instrument-info-page' }: SurveyEntryScreenProps) {
  return (
    <Box data-testid={testId} sx={surveyEntryPageRootSx}>
      <SurveyEntryCard>{children}</SurveyEntryCard>
    </Box>
  )
}
